import { Fatura } from '../types/MobileLine';

export interface FaturaSGP {
  id: string;
  valor: number;
  vencimento: string; 
  vencimento_atualizado?: string;
  status: string;    
  link: string;
}

// ✅ Verifica se a fatura está vencida
export const isFaturaVencida = (vencimento: string): boolean => {
  const hoje = new Date();
  const dataVencimento = new Date(vencimento);
  return dataVencimento < hoje;
};

// ✅ Encontra a fatura vencida mais antiga (não paga) - usa vencimento REAL, não atualizado
export const encontrarFaturaVencidaMaisAntiga = (faturas: (FaturaSGP | Fatura)[]): (FaturaSGP | Fatura) | null => {
  const faturasVencidas = faturas.filter(f => {
    // Usar SEMPRE vencimento (data real do boleto), nunca vencimento_atualizado
    const dataVencimento = f.vencimento;
    // Incluir apenas faturas "Gerado" (não pagas) e que estão vencidas
    return (f as any).status === 'Gerado' && isFaturaVencida(dataVencimento);
  });

  if (faturasVencidas.length === 0) return null;

  // Ordenar por vencimento (mais antigo primeiro) e retornar o primeiro
  return faturasVencidas.sort((a, b) => {
    const dataA = new Date(a.vencimento);
    const dataB = new Date(b.vencimento);
    return dataA.getTime() - dataB.getTime();
  })[0];
};

export const formatarValor = (valor: number): string => {
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};


export const formatarData = (data: string): string => {
  const d = new Date(data);
  return d.toLocaleDateString('pt-BR');
};


export const filtrarFaturasPendentes = (faturas: FaturaSGP[]): FaturaSGP[] => {
  return faturas.filter(f => f.status === 'EM ABERTO' || f.status === 'VENCIDA');
};


export const calcularTotalAberto = (faturas: FaturaSGP[]): number => {
  return filtrarFaturasPendentes(faturas).reduce((total, f) => total + f.valor, 0);
};
